import React from "react";
import "./HeroSection.css";
// import heroImage from "https://exitocol.vtexassets.com/arquivos/ids/11239444/maquina-patillera-barbera-buda-t99.jpg"; // Añade la imagen del producto

const imagen = 'https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/landings%2Fmaquina%2FCaptura_de_pantalla_2024-11-28_112844-removebg-preview.png?alt=media&token=f62fd637-c92b-4cbd-96e5-605cf2b6f650'
 const click = ()=>{
  window.location.href = 'https://w.app/MegalotoTrimmerBuda';
  
 }

const HeroSection = () => (
  <section className="hero">
    <div className="hero-content">
      <h2>¡ÚNETE AL SORTEO Y GANA NO SOLO UNA, SINO LLEVATE DOS TRIMMER BUDA!</h2>
      <button className="cta-button" onClick={click}>¡RESERVA TU NÚMERO AHORA!</button>
    </div>
    <img src={imagen} alt="Trimmer Buda" className="hero-image" />
  </section>
);

export default HeroSection;
